var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
library.add(fas);
library.add(fal);
export const Icon = _ref => {
  let {
    type,
    fixedWidth,
    style,
    className,
    faStyle
  } = _ref;
  return /*#__PURE__*/React.createElement(IconContainer, {
    width: fixedWidth,
    style: style,
    className: className
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: [faStyle ? faStyle : 'fal', type],
    size: "lg"
  }));
};
const IconContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  text-align: center;\n  display: inline-block;\n  margin-top: -2px;\n"])), p => p.width);
export default Icon;